export default __webpack_public_path__ + "static/blackBackground-7807571f98948c7c80be9e41dbc58eea.png";